import { addMonths, format, isSameDay } from 'date-fns';
import { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import { DatePicker } from './DatePicker';
import { TimePicker } from 'components/inputs/Time/TimePicker';

const StyledDiv = styled.div`
  display: flex;
  align-items: center;
  padding-left: 25px;
  .ant-picker-input {
    margin-right: 10px;
  }
  .ant-picker {
    &:last-of-type {
      margin-left: 10px;
    }
  }
  .time-picker {
    margin-top: 26px;
    margin-right: 10px;
  }
  input {
    margin-right: 0 !important;
  }
`;

type DateTimePickerProps = {
  onChange: (arg: string) => void;
  defaultValue?: Date;
  minDate?: Date;
  id?: string
};


export default function DateTimePicker({ onChange, defaultValue, minDate, id = "date-picker" }: DateTimePickerProps) {

  const [selectedDate, setSelectedDate] = useState<Date | undefined>(defaultValue || new Date());
  const [selectedTime, setSelectedTime] = useState(defaultValue ? format(defaultValue, 'HH:mm') : "");

  const { minHour, minMinute } = useMemo(() => {
    if (!minDate || !selectedDate || !isSameDay(selectedDate, minDate)) {
      return { minHour: 0, minMinute: 0 }
    }
    return { minHour: minDate.getHours(), minMinute: minDate.getMinutes() }

  }, [minDate, selectedDate])

  useEffect(() => {
    if (selectedDate && selectedTime) {
      const result = selectedDate;
      result?.setHours(parseInt(selectedTime.split(":")[0]))
      result?.setMinutes(parseInt(selectedTime.split(":")[1]))

      onChange(result.toISOString());
    }
  }, [selectedDate, selectedTime, onChange])

  return (
    <StyledDiv>
      <DatePicker
        id={id}
        onChange={(date) => setSelectedDate(date)}
        minDate={minDate}
        maxDate={addMonths(new Date(), 2)}
        value={selectedDate}
      />
      <TimePicker
        id={`${id}-time`}
        value={selectedTime}
        onChange={setSelectedTime}
        minHour={minHour}
        minMinutes={minMinute}
      />
    </StyledDiv>
  );
}
